module.exports = __webpack_public_path__ + "img/comentarios.b3446089.svg";